import axios from 'axios'
import api from '@/config/apis.js'
import Cookies from 'js-cookie'

axios.defaults.baseURL = api.apiUrl
axios.interceptors.request.use(config => {
  if (config.url !== '/auth/oauth/token' && Cookies.get('access_token')) {
    config.headers['Authorization'] = 'Bearer ' + Cookies.get('access_token') || '';
  }
  return config;
}, error => {
  return Promise.reject(error);
});
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })  //QS.stringify()
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
